import React from 'react';

import {ReactComponent as England} from './svg/gb.svg';
import {ReactComponent as Nederland} from './svg/nl.svg';
import {ReactComponent as German} from './svg/de.svg';
import {ReactComponent as Lithuania} from './svg/lt.svg';

const Flag = ({name, size, color, ...props}) => {
    const iconProps = {
        ...props,
        style: {
            stroke: color,
            fill: color,
            width: size,
            height: size
        }
    };

    switch(name) {
        case 'en':
            return <England {...iconProps} />;
        case 'nl':
            return <Nederland {...iconProps} />;
        case 'lt':
            return <Lithuania {...iconProps} />;
        default:
            return <German {...iconProps} />;
    }
};

export default Flag